// Copyright (c) 2019 Deere & Company

import './text-dropdown.scss';
import React, { Component, createRef } from 'react';
import { DropdownPopover } from './dropdown-popover';
import { Overlay } from 'react-overlays';
import PropTypes from 'prop-types';

export class TextDropdown extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showOverlay: false,
        };

        // ✅ refs for overlay positioning + container
        this.containerRef = createRef();
        this.targetRef = createRef();
    }

    displayOverlay = (e) => {
        // ✅ prevent bubbling causing immediate close
        e.stopPropagation();
        this.setState({ showOverlay: true });
    };

    hideOverlay = () => {
        this.setState({ showOverlay: false });
    };

    render() {

        const { showOverlay } = this.state;

        const arrowClass = showOverlay
            ? 'popover-caret with-arrow'
            : 'popover-caret';

        return (
            <div className="text-dropdown" ref={this.containerRef}>

                <div
                    className="text-display"
                    ref={this.targetRef}
                    onClick={this.displayOverlay}
                >
                    <span className="dropdown-text">
                        {this.props.text}
                    </span>
                    <span className={arrowClass} />
                </div>

                <Overlay
                    container={this.containerRef.current}
                    target={this.targetRef.current}
                    show={showOverlay}
                    onHide={this.hideOverlay}
                    placement="top"
                    rootClose
                >
                    {({ props }) => (
                        <div {...props} className="dropdown-overlay">
                            <DropdownPopover onMenuItemClick={this.hideOverlay}>
                                {this.props.children}
                            </DropdownPopover>
                        </div>
                    )}
                </Overlay>

            </div>
        );
    }
}

TextDropdown.propTypes = {
    text: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};